import i18n from 'i18next';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import pckg from '../package.json';

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/static/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: pckg.version },
    },
    fallbackLng: 'en',
    debug: false,
    ns: 'customer',
    defaultNS: 'customer',
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
